import { useMongoAdd, useMongoAdds, useMongoDelete } from "contexts/useMongoQuery";

const useBookingsMutations = () => {
  return {
    addBooking: useAddBooking(),
    addBookings: useAddBookings(),
    deleteBooking: useDeleteBooking(),
    deleteBookingByDock: useDeleteBookingByDock(),
  };
}
export default useBookingsMutations

const useAddBooking = () => {
  const [addBookingMutation] = useMongoAdd("bookings");
  const addBooking = async (booking: any) => {
    // @ts-ignore
    const { addedBooking } = await addBookingMutation({
        bookingMethod: 2,
        updated: new Date(),
        ...booking,
    });
    return addedBooking;
  };
  return addBooking;
}

const useAddBookings = () => {
  const [addBookingsMutation] = useMongoAdds("bookings");
  const addBookings = async (bookings: any[]) => {
    // @ts-ignore
    const { addedBookings } = await addBookingsMutation(bookings);
    return addedBookings;
  };
  return addBookings;
}

const useDeleteBooking = () => {
  const [deleteBookingMutation] = useMongoDelete("bookings");

  const deleteBooking = async (booking: any) => {
    // @ts-ignore
    const deletedBooking = await deleteBookingMutation({ _id: booking._id });
    return deletedBooking;
  };
  return deleteBooking;
}

const useDeleteBookingByDock = () => {
  const [deleteBookingMutation] = useMongoDelete("bookings", true);
  const deleteBooking = async (booking: any) => {
    // @ts-ignore
    const deletedBooking = await deleteBookingMutation({ dockID: String(booking.dockID), bookingStatus: { $nin: [3,4] } });
    return deletedBooking;
  };
  return deleteBooking;
}
